<template>
  <!-- 新解析器 -->
  <div class="">
    <v-dialog
    class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >

      <v-form ref="form" :model="ruleForm" :rules="rules">

        <v-form-item  prop="productKey" >
          <template slot="label">
            <span class="required">*</span>
            <span>产品</span>
          </template>
          <!-- <v-select id="productKey" name="productKey" :placeholder="productKeyOptins.length > 0 ? '请选择' : '请先新建产品'" v-model="productKey" @change="getDevList" :options="productKeyOptins"></v-select> -->
          <v-select id="productKey" name="productKey" :placeholder="productKeyOptins.length > 0 ? '请选择' : '请先新建产品'" v-model="productKey" :options="productKeyOptins"></v-select>
        </v-form-item>
        <!-- <v-form-item  prop="devKey" >
          <template slot="label">
            <span class="required">*</span>
            <span>设备</span>
          </template>
          <v-select1 id="devKey" isSearch @searchData="changeSearch" :disabled="devKeyOptins.length === 0" name="devKey" v-model="devKey" @change="getTopicList" :options="devKeyOptins"></v-select1>
        </v-form-item> -->
        <v-form-item  prop="topic" >
          <template slot="label">
            <span class="required">*</span>
            <span>topic</span>
          </template>
          <!-- <v-select id="topic" :disabled="topicOptins.length === 0"  name="topic" v-model="ruleForm.topic" :options="topicOptins"></v-select> -->
          <v-input type="text" name="topic" v-model="ruleForm.topic"></v-input>
        </v-form-item>
      </v-form>
    </v-dialog>

  </div>

</template>

<script>
export default {
  components: {},
  props:{
  showInputDialog:{
    type:Boolean,
    default: false
  },
  sourceId:{
    type: Number,
    require: true
  }
},
  data() {
    return {
      rules: {},
      ruleForm:{
        source_id: "",
        topic: "",
        app_id: sessionStorage.getItem("appid") || "",
      },

      dialogTitle: "创建Topic",
      isShow:false,
      productKey:'',
      productKeyOptins:[],
      devKey:'',
      devKeyOptins:[],
      topicOptins:[],
      searchDevName:''
    };
  },
  created() {
    this.ruleForm.source_id = this.$props.sourceId
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    changeSearch(data){
      this.searchDevName = data
      this.getDevList()
    },
    open(){
      this.getProductList()
    },
    getProductList(){
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
      }
      this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.productKeyOptins = res.data.map((item) =>{
            return {
              label: item.product_name,
              value: item.product_key
            }
          })
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    getDevList(){
      this.topicOptins = []
      this.devKey = ''
      this.ruleForm.topic = ''
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        size: 1000,
        dev_name: this.searchDevName
      }
      this.$post("/td/td-iot-api/iot/common/dev/list/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.devKeyOptins = res.data.map((item) =>{
            return {
              label: item.dev_name,
              value: item.dev_key
            }
          })
        }else {
          this.$message.error(res.msg);
        }
      });
      // this.searchDevName = ''
    },
    getTopicList(){
      this.ruleForm.topic = ''
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        dev_key: this.devKey,
        topic_power: 'pub'
      }
      this.$post("/td/td-iot-api/iot/common/dev/topics/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.topicOptins = res.data.map((item) =>{
            return {
              label: item.topic_desc,
              value: item.topic
            }
          })
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }

      let submitData = { ...this.ruleForm };
      submitData.product_key = this.productKey
      this.$post("/td/td-iot-api/iot/rule/topic/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
      this.ruleForm.source_id = this.$props.sourceId
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
      Object.assign(this.$data, this.$options.data())
      this.ruleForm.source_id = this.$props.sourceId
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">

</style>
